// Fragment "HQ Solunary Services leads" — merged into ./index.js.
// Convention: flat dotted keys, values in the 3 languages, never empty.
// Backs super_admin/HqServiceLeads.jsx (the cross-tenant view of the interest CTA
// on the practitioner's Subscription page).
export default {
  fr: {
    "nav.hqServiceLeads": "Demandes de services",
    "sl.title": "Demandes Solunary Services",
    "sl.subtitle": "Intérêts exprimés par les praticiens depuis leur page Abonnement, tous cabinets confondus.",
    "sl.refresh": "Rafraîchir",
    "sl.colTenant": "Praticien",
    "sl.colTier": "Palier",
    "sl.colEmail": "Courriel",
    "sl.colMessage": "Message",
    "sl.colCreated": "Reçue le",
    "sl.colStatus": "Statut",
    "sl.status.new": "Nouvelle",
    "sl.status.contacted": "Contacté",
    "sl.status.closed": "Clôturée",
    "sl.allTiers": "— Tous les paliers —",
    "sl.allStatuses": "— Tous les statuts —",
    "sl.noMessage": "Aucun message",
    "sl.empty": "Aucune demande pour l'instant.",
    "sl.updated": "Statut mis à jour.",
    "sl.error": "Action impossible.",
    "sl.workedBy": "Traitée par",
    "sl.automationHint": "L'alerte courriel se configure dans HQ → Automations, déclencheur « service.interest » (modèle « Solunary Services interest »).",
  },
  en: {
    "nav.hqServiceLeads": "Service leads",
    "sl.title": "Solunary Services leads",
    "sl.subtitle": "Interest expressed by practitioners from their Subscription page, across every tenant.",
    "sl.refresh": "Refresh",
    "sl.colTenant": "Practitioner",
    "sl.colTier": "Tier",
    "sl.colEmail": "Email",
    "sl.colMessage": "Message",
    "sl.colCreated": "Received",
    "sl.colStatus": "Status",
    "sl.status.new": "New",
    "sl.status.contacted": "Contacted",
    "sl.status.closed": "Closed",
    "sl.allTiers": "— All tiers —",
    "sl.allStatuses": "— All statuses —",
    "sl.noMessage": "No message",
    "sl.empty": "No leads yet.",
    "sl.updated": "Status updated.",
    "sl.error": "Action failed.",
    "sl.workedBy": "Worked by",
    "sl.automationHint": "The email alert is configured in HQ → Automations, trigger “service.interest” (template “Solunary Services interest”).",
  },
  es: {
    "nav.hqServiceLeads": "Solicitudes de servicios",
    "sl.title": "Solicitudes de Solunary Services",
    "sl.subtitle": "Interés expresado por los profesionales desde su página de Suscripción, en todas las consultas.",
    "sl.refresh": "Actualizar",
    "sl.colTenant": "Profesional",
    "sl.colTier": "Nivel",
    "sl.colEmail": "Correo",
    "sl.colMessage": "Mensaje",
    "sl.colCreated": "Recibida",
    "sl.colStatus": "Estado",
    "sl.status.new": "Nueva",
    "sl.status.contacted": "Contactado",
    "sl.status.closed": "Cerrada",
    "sl.allTiers": "— Todos los niveles —",
    "sl.allStatuses": "— Todos los estados —",
    "sl.noMessage": "Sin mensaje",
    "sl.empty": "Todavía no hay solicitudes.",
    "sl.updated": "Estado actualizado.",
    "sl.error": "Acción imposible.",
    "sl.workedBy": "Atendida por",
    "sl.automationHint": "La alerta por correo se configura en HQ → Automations, disparador “service.interest” (plantilla “Solunary Services interest”).",
  },
};
